export const getReviewsAllReviews = (state) =>
  state?.reviews?.reviews?.data?.all

export const getReviewsAllStats = (state) => state?.reviews?.stats?.all?.data

export const getReviewsProductsReviews = (state) =>
  state?.reviews?.reviews?.data

export const getReviewsProductsStats = (state) =>
  state?.reviews?.stats?.products?.data

export const getReviewsSiteStats = (state) => state?.reviews?.stats?.site?.data
